export default "__VITE_ASSET__imHTnKIT__"